import {
  TOpenSourceLicense,
} from './table-open-source-licenses.ts';

const licenseColumn: Record<keyof TOpenSourceLicense, string> = {
  name: 'Knižnica / Projekt',
  version: 'Verzia',
  license: 'Licencia',
  url: 'Domovská stránka',
  notice: 'Obsah licencie',
  notice_url: 'URL licencie',
  package_url: 'URL v úložisku balíkov',
};

export default {
  licenseColumn,
};
